export {};
//# sourceMappingURL=style-spec-mapbox.js.map